import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import {
    toggleSortByBoxWeb,
    applySortByBoth
} from './../../../actions/FilterActions';
import OutsideNotifier from '../../../OutsideNotifier';
import common from '../../../common';
import config from './../../../config';

class SortByFilterWeb extends Component {
    onSortOpen = () => {
        if (this.props.playerRecomendedSelectedKey == config.playerRecomendationDefault) {
            this.props.toggleSortByBoxWeb();
            if (!this.props.isSortByOpenForWeb) {
                let pageName = "";
                if (window.location.pathname.indexOf("/manage-team")) {
                    pageName = "/uclfantasy/my-team/transfers/"
                } else {
                    pageName = "/uclfantasy/create-team/"
                }
                common.customTracking('Sort By - Filters', pageName);
            }
        } else {

        }

    };
    onSortApply = (sortOption) => {
        this.props.applySortByBoth(sortOption);
        common.customTracking('Select Sort By filter -' + config.sortByArrTracking[sortOption], common.getPageName());
        this.props.toggleSortByBoxWeb();
    };

    resetSortBy = (e) => {
        e.stopPropagation();
        if (this.props.playerRecomendedSelectedKey == config.playerRecomendationDefault) {
            this.props.applySortByBoth(config.defaultSortBy);
        }

    }

    render() {
        const sortClass = common.makeClasses({
            'si-selectBoxes': true,
            'si-active': this.props.isSortByOpenForWeb
        });

        const classNameParent = common.makeClasses({
            'si-sorting-filter': true,
            'si-more-filters': true,
            'si-disabled-filter': this.props.playerRecomendedSelectedKey == config.playerRecomendationDefault ? false : true
        })

        const selectedClass = common.makeClasses({
            "si-dropdown-btn": true,
            "si-flexBox": true,
            "si-selected-option": this.props.sortBy != config.defaultSortBy
        })
        return <div className={ classNameParent }>
            <div className="si-dropdown-wrap">
                <div className={ sortClass }>
                    <div className={ selectedClass }
                        onClick={ () => this.onSortOpen() }>
                        <span>{ this.props.trans[this.props.sortBy] ? this.props.trans[this.props.sortBy] : this.props.sortBy }</span>
                        { this.props.sortBy == config.defaultSortBy ? null : <span className="si-close" onClick={ (e) => this.resetSortBy(e) }>
                            <i className="icon-ucl-close"></i>
                        </span> }
                        <i className="icon-ucl-position"></i>
                    </div>
                    { this.props.isSortByOpenForWeb ? <OutsideNotifier handler={ () => this.onSortOpen() }>
                        <ul className="si-dropdown-options">
                            <Scrollbars autoHide>
                                { this.props.sortByArr.map((el) => {
                                    const className = common.makeClasses({
                                        'si-active': el === this.props.sortBy
                                    });
                                    return <li
                                        className={ className }
                                        key={ el }
                                        onClick={ () => this.onSortApply(el) }>{ this.props.trans[el] ? this.props.trans[el] : el }</li>
                                }) }
                            </Scrollbars>
                        </ul>
                    </OutsideNotifier> : null }
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        sortByArr: state.formationData.sortByArr,
        isSortByOpenForWeb: state.formationData.isSortByOpenForWeb,
        sortBy: state.formationData.playerFilters.sortBy,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleSortByBoxWeb: () => dispatch(toggleSortByBoxWeb()),
        applySortByBoth: (sortOption) => dispatch(applySortByBoth(sortOption)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SortByFilterWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/SortByFilterWeb.js